import { SwipeluxWidget } from "./sdk";
import { SwipeluxWidgetElement } from "./web-component";

declare global {
  interface Window {
    SwipeluxWidget: typeof SwipeluxWidget;
    SwipeluxWidgetElement: typeof SwipeluxWidgetElement;
  }
}

window.SwipeluxWidget = SwipeluxWidget;
window.SwipeluxWidgetElement = SwipeluxWidgetElement;

customElements.define("swipelux-widget", SwipeluxWidgetElement);
